<template>
	<invoices-table :invoices="invoices" :top-paging="false" simplify title-bar actionable>
		<create-invoice :project="project" />
	</invoices-table>
</template>
<script>
import InvoicesTable from '@/Pages/Backend/Invoices/Table'
import CreateInvoice from '@/Pages/Backend/Invoices/Create'

export default {
	components: {
		InvoicesTable,
		CreateInvoice
	},
	props: {
		invoices: {
			type: [Array, Object],
			default: () => {},
			required: true
		}
	},
	data () {
		return {
			project: this.$page.props.project
		}
	}
}
</script>
